import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="forgot-password-page" className="min-h-screen bg-[#0B1120] flex items-center justify-center px-6">
      <form
        data-testid="forgot-password-form"
        onSubmit={submit}
        className="w-full max-w-sm bg-[#0F172A] border border-white/10 p-10"
      >
        <p className="font-display font-semibold text-white text-xl mb-2">Reset password</p>
        <p className="text-xs text-slate-500 mb-8">
          Enter your admin email and we'll send you a reset link (valid for 1 hour).
        </p>
        {done ? (
          <p data-testid="forgot-success" className="text-sm text-emerald-400 leading-relaxed">
            If an account exists for that email, a reset link is on its way. Check your inbox.
          </p>
        ) : (
          <>
            <Input
              data-testid="forgot-email-input"
              type="email"
              required
              placeholder="Admin email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#0B1120] border-white/10 text-slate-100 placeholder:text-slate-600 focus-visible:ring-[#ED1C24] rounded-none h-12"
            />
            {error && <p data-testid="forgot-error" className="text-[#ED1C24] text-xs mt-4">{error}</p>}
            <button
              data-testid="forgot-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full mt-6 inline-flex items-center justify-center gap-2 bg-[#ED1C24] hover:bg-[#C81016] disabled:opacity-60 text-white font-medium py-3.5 transition-colors duration-300"
            >
              <Mail size={15} />
              {loading ? "Sending..." : "Send reset link"}
            </button>
          </>
        )}
        <Link
          data-testid="forgot-back-link"
          to="/admin/login"
          className="block text-center mt-6 text-xs text-slate-500 hover:text-[#FFC61A] transition-colors duration-300"
        >
          ← Back to sign in
        </Link>
      </form>
    </main>
  );
}
